function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M150 300C232.843 300 300 232.843 300 150C300 67.1573 232.843 0 150 0C67.1573 0 0 67.1573 0 150C0 232.843 67.1573 300 150 300Z",
  fill: "#B2A1FB"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M51 150C51 142.586 52.4145 136.108 55.2434 130.565C58.1413 124.952 62.2467 120.622 67.5595 117.573C72.9414 114.524 79.2547 113 86.4995 113C92.1573 113 97.2286 114.109 101.714 116.326C106.198 118.543 109.821 121.661 112.581 125.68C115.341 129.699 116.997 134.341 117.549 139.607H102.024C101.127 135.449 99.2296 132.193 96.3317 129.837C93.5028 127.412 89.9494 126.199 85.6715 126.199C79.8757 126.199 75.2873 128.382 71.9064 132.747C68.5255 137.112 66.835 142.863 66.835 150C66.835 157.067 68.5255 162.818 71.9064 167.253C75.2873 171.618 79.8757 173.801 85.6715 173.801C89.9494 173.801 93.5028 172.623 96.3317 170.267C99.2296 167.842 101.127 164.551 102.024 160.393H117.549C116.997 165.659 115.341 170.301 112.581 174.32C109.821 178.339 106.198 181.457 101.714 183.674C97.2286 185.891 92.1573 187 86.4995 187C79.2547 187 72.9414 185.476 67.5595 182.427C62.2467 179.378 58.1413 175.082 55.2434 169.539C52.4145 163.927 51 157.414 51 150Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M126.568 113.624L175.212 113.624V127.031L142.093 127.031V143.348H169.002V156.132H142.093V172.969H176.35V186.376L126.568 186.376L126.568 113.624Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M204.738 149.272L182.176 113.624H201.012L215.295 136.489L229.888 113.624H246.862L224.299 149.272L248 186.376L229.06 186.376L213.639 161.952L197.907 186.376H181.037L204.738 149.272Z",
  fill: "white"
});

var SvgCex = function SvgCex(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCex, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CEX.cfe22ac4.svg";
export { ForwardRef as ReactComponent };